import { BaseModel } from '../../_base/crud';
import {EarnedPoints} from "../../../model/club-gigot/user-points/calculate-earned-points.dto";

export class Order extends BaseModel {
    id: number;
    campaignNumber: string;
    creationDate: string;
    userName: string;
    firstName: string;
    lastName: string;
    orderEventOriginType: string;
    orderEventTypeId: number;
    orderEventStatus: string;
    orderId: number;
    orderEventItems: any[];
    applicationUserId: any;
    orderEventTrackings: any[];
    replacementItems: any[];
    orderEventProducts: any;
    orderEventResultId: any;
}

export class OrderItem {
    id: number;
    campaignProductId: number;
    productCode: number;
    productName: string;
    price: number;
    finalPrice: number;
    profit: number;
    quantity: number;
    stock: number;
    paymentCycle: number;
    totalPaymentCycle: number;
    imagePath: string;
    isGift: boolean;
    promotionPrice: number;
    promotionPriceQuantity: number;
    finalDiscountedPrice: number;
    orderItemStatus: string;
    isReplacement: boolean;
    isSuggested: boolean;
    isHidden: boolean;
    isReturn: boolean;
    isPreviousNoStock: boolean;
    public requisiteQuantity: number;
    public isPromotionDeletable: boolean;
    public promotionIds: string[];
    public isPoints: boolean;
    public promotionDeletableQuantity: number;
    public isPointsDeletable: boolean;
}

export class noStockReplacementItem {
    productCode: number;
    productName: string;
    quantity: number;
}

export class OrderTracking {
    id: number;
    orderId: number;
    orderStatus: string;
    timestamp: string;
}

export class OrderCart {
    id: number;
    orderDate: string;
    orderStatus: string;
    campaignNumber: string;
    campaignId: number;
    orderItems: OrderItem[];
    orderTracking: OrderTracking[];
    orderGiftChoices: ProductGroupGiftRewards[];
    applicationUser: Profile;
    invoiceTypeLabel: string;
    netAmount: number;
    excemptTaxAmount: number;
    vatAmount: number;
    grossIncomePercentageAmount: number;
    grossIncomeTaxAmount: number;
    grossIncomeLabel: string;
    shippingAmount: number;
    noStockReplacements: noStockReplacementItem[];
    orderPoints : OrderPointsDTO;
    earnedPoints: EarnedPoints;
    ivaNoCatTaxAmount: number;
}

export class OrderPointsDTO {
    referrerUserName : string;
    orderSequences : number[];
}

export class ProductGroupGiftRewards {
    id: number;
    value: number;
    products: ProductGift[];
}

export class ProductGift {
    orderItemId: number;
    code: string;
    name: string;
    quantity: number;
}


export class Profile {
    id: string;
    userName: number;
    email: string;
    emailConfirmed: boolean;
    phoneNumber: string;
    phoneNumberConfirmed: boolean;
    lastName: string;
    firstName: string;
    documentNumber: number;
    cuil: number;
    homePhone: number;
    birthDate: string;
    sex: string;
    nationality: string;
    condicionIVAId: string;
    isActive: boolean;
    entornoLogistico: boolean;
    address: AddressUser;
    userFiles: UserFile[];
    roles: string;
    personalReferences: PersonalReference[];
    authorizePhonesDisclosure: boolean;
    wantToReceiveNewsletter: boolean;
    isFounder: boolean;
    documentType: string;
    profileStatusType: 'string';
    profileCompletionDate: string;
}

export class AddressUser {
    region: string;
    locality: string;
    province: string;
    postalCode: number;
    neighborhood: string;
    street: string;
    number: number;
    floor: string;
    apartment: string;
    complement: string;
    latitude: number;
    longitude: number;
}

export class UserFile {
    fileName: string;
    url: string;
    fileType: number;
    validated: boolean;
}

export class PersonalReference {
    id: number;
    lastName: string;
    firstName: string;
    documentNumber: string;
    mobilePhone: string;
    homePhone: string;
    address: string;
}

export class RankingProducts {
    codigoProducto: number;
    nombreProducto: string;
    cantEnviada: number;
    cantRevendedora: number;
    facturacion: number;
    precioLista: number;
    precioCN: number;
}
